<template>
  <footer :class="['footer',  _isMobile()?'mobile':'']">
    <a-row type="flex" justify="space-between">
      <a-col :xs="24" :sm="12" :md="5" :lg="7" :xl="7">
        <img class="logo" :src="tenantInfo && tenantInfo.logo ? tenantInfo.logo : '/img/logo.png'" alt=""/>
      </a-col>
      <a-col :xs="24" :sm="12" :md="19" :lg="17" :xl="17">
        <div v-html="tenantInfo && tenantInfo.footer" style="text-align:left"></div>
      </a-col>
    </a-row>
  </footer>
</template>
<script>
import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
import {mixinDevice} from '@/utils/mixin.js'

export default {
  name: "Footer",
  mixins: [mixinDevice],
  data() {
    return {
      year: new Date().getFullYear(),
      tenantInfo: {},
    };
  },
  created() {
    this.tenantInfo = this.$store.getters.tenantInfo
  },
};
</script>
<style lang="less" scoped>
.mobile{
  padding-left:25px;
  padding-right:25px;
  min-height: 120px!important;
}
footer {
  // background: #2B8AB9 url(../assets/footerbg.png) no-repeat;
  color: white;
  width: 100%;
  min-height: 250px;
  bottom:0;
  padding-top: 40px;
  padding-bottom: 15px;
  text-align: center;
}
.logo{
  max-width:200px
}
</style>